export enum VideoStartFailedReason {
  PageClosed = 'PAGE_CLOSED',
  PlayerError = 'PLAYER_ERROR',
  Timeout = 'TIMEOUT',
  Unknown = 'UNKNOWN'
}
